const InfoCard = () => {
    return (<div className="bg-white rounded-lg border border-slate-200 shadow-sm p-4 flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-amber-50">
          <i className="ri-information-line text-amber-600 text-xs"/>
        </div>
        <h4 className="text-xs font-semibold text-slate-700">운영 도구 기준</h4>
      </div>
      <p className="text-xs leading-relaxed text-slate-500" style={{ wordBreak: "keep-all" }}>
        이 화면에서는 조회만 수행합니다. 데이터 생성·보정 작업은 영향 범위와 감사 계약이 승인된 별도 관리 기능에서만 제공합니다.
      </p>
    </div>);
};
export default InfoCard;
